import { Pair } from './pair'
import { Owner } from './user'
import { Word } from './word'

export class Dictionary {
  id: number
  owner: Owner
  title: string
  description: string
  words: Word[]
  pairs: Pair[]
  likes: number
  is_liked: boolean
  bookmarks: number
  is_bookmarked: boolean
  words_count: number
  pairs_count: number
  is_mine: boolean
  created_at: string
  last_update: string
  time_since_creation: string
  slug: string | null
  ai_generated: boolean = false
}

export class SimpleDictionary {
  id: number
  title: string
}
